export class EditTemplateContext {
    fieldsToFill = []

    setFieldsToFill(fields) {
        this.fieldsToFill = fields;
    }
}